export const horizontalNavBarComponentId = 'app-market-horizontal-nav-bar';
